/**
 * @description Enum for the type of student
 * @todo Refactor to use the `StudentTypesEnum` enum from `api/enums.ts`
 */
export enum StudentTypes {
  'I am not a student' = 0,
  'High School' = 1,
  'Tafe' = 2,
  'University' = 3
}

/**
 * @description Enum for the type of Gender
 * @todo Refactor to use the `GenderEnum` enum from `api/enums.ts`
 */
export enum GenderEnum {
  Female = 1,
  Male = 2,
  Other = 0,
  'Prefer not to say' = 3
}

/**
 * @description Enum for the type of DietaryPreference
 */
export enum DietaryPreferenceEnum {
  No = 0,
  DairyFree,
  GlutenFree,
  LowCarb,
  Vegetarian,
  Vegan
}

/**
 * @description Enum for the type of Household (KidAtHome)
 */
export enum HouseholdEnum {
  No = 0,
  PreSchool,
  PrimarySchool,
  SecondarySchool,
  Over18
}

export interface FormFieldElement {
  label: string
  placeholder?: string
  helper?: string
}

export enum CateringOccasionTypes {
  Corporate = 1,
  Birthday,
  'Friends gathering',
  Sport,
  Seasonal,
  Other
}
